import React from "react";
import { mediaUrl } from "@/lib/api";

export const Media = ({ item, className = "", testId }) => {
  if (!item?.url) return null;
  const src = mediaUrl(item.url);
  if (item.type === "video") {
    return (
      <video data-testid={testId} src={src} controls playsInline
        className={`w-full h-full object-cover bg-black ${className}`} />
    );
  }
  return <img data-testid={testId} src={src} alt="" className={`w-full h-full object-cover ${className}`} />;
};

export default Media;
